import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Card, CardHeader, Container, Row, Spinner } from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import Swal from "sweetalert2";
import { removeWidgetItem } from "consts/Constants";
import AddCustomFieldModal from "./AddCustomFieldModal";

const { SearchBar } = Search;

export default function AdminCaseCustomFields(props) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fields, setFields] = useState([]);
  const [currentModel, setCurrenModel] = useState({});

  const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({
      options,
      currSizePerPage,
      onSizePerPageChange,
    }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  });

  const getItems = () => {
    setLoading(true);
    axiosConfig
      .get("admin/cases/custom_fields/index")
      .then((res) => {
        setLoading(false);
        setFields(res.data.result.custom_fields);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getItems();
  }, []);

  const removeItem = (id) => {
    removeWidgetItem("admin/cases/custom_fields/delete/" + id, getItems);
  };
  return (
    <>
      <ListHeader
        name="Case Custom Fields"
        parentName="Dashboard"
        setShowModal={setShowModal}
        setCurrenModel={setCurrenModel}
      />

      <AddCustomFieldModal
        showModal={showModal}
        toggleModal={setShowModal}
        currentModel={currentModel}
        setCurrenModel={setCurrenModel}
        title={"Custom Field"}
        getItems={getItems}
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Client Fields</h3>
              </CardHeader>
              <ToolkitProvider
                data={fields}
                keyField="id"
                columns={[
                  {
                    dataField: "name",
                    text: "Name",
                    sort: true,
                  },
                  {
                    dataField: "type",
                    text: "Type",
                    sort: true,
                  },
                  {
                    dataField: "options",
                    text: "Options",
                    sort: true,
                    formatter: (cell, row) => {
                      return (
                        <span>
                          {row.options ? row.options.toString() : "-"}
                        </span>
                      );
                    },
                  },
                  {
                    dataField: "name",
                    text: "Actions",
                    editable: true,
                    sort: false,
                    formatter: (cell, row) => {
                      return (
                        <>
                          <a
                            className="btn btn-info btn-sm"
                            onClick={() => {
                              setCurrenModel(row);
                              setShowModal(true);
                            }}
                          >
                            <i className="fa fa-pen" />
                          </a>
                          <a
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              Swal.fire({
                                title: "Are you sure?",
                                text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  removeItem(row.id);
                                }
                              })
                            }
                          >
                            <i className="fa fa-trash" />
                          </a>
                        </>
                      );
                    },
                  },
                ]}
                search
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1"
                    >
                      <label>
                        Search:
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={false}
                      hover={true}
                      noDataIndication={
                        loading ? (
                          <Spinner color="info" size="xl" />
                        ) : (
                          <p>No Fields yet!</p>
                        )
                      }
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
